export function peopleList() {
    const _document = this._document;
    const isDesk = !this.isTouch;
    const list = _document.querySelector(".people-list");
    const people = list.querySelectorAll(".person");

    if(isDesk) {
        for(const person of people) {
            const link = person.querySelector(".focus-link");
            const linkParent = link.parentElement;
            const socials = linkParent.querySelectorAll(".socials a");  
            link && link.addEventListener("focus", () => {
                linkParent.classList.add("active");
                _document.addEventListener("keydown", (event) => {
                    if(event.keyCode === 9) {
                        setTimeout(() => {
                            if(person.querySelector("a:focus")) {
                                if(!person.classList.contains("active")) {
                                    person.classList.add("active");
                                }
                            } else {
                                person.classList.remove("active");
                            }
                        }, 100);
                    }
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/people-list.js